function toDate(value) {
  return value instanceof Date ? value : new Date(value);
}

function getLocalDayNumber(date) {
  return Math.floor(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()) / 86400000);
}

function formatLocalTime(date) {
  return new Intl.DateTimeFormat(undefined, {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false
  }).format(date);
}

function formatLocalDate(date) {
  return new Intl.DateTimeFormat(undefined, {
    year: "numeric",
    month: "long",
    day: "numeric"
  }).format(date);
}

export function describeTimeAgo(value, options = {}) {
  const targetDate = toDate(value);
  const referenceDate = toDate(options.now ?? new Date());

  if (Number.isNaN(targetDate.getTime()) || Number.isNaN(referenceDate.getTime())) {
    return {
      key: "messages.timeAgo.invalid",
      params: {}
    };
  }

  const elapsedMs = Math.max(0, referenceDate.getTime() - targetDate.getTime());
  const elapsedMinutes = Math.floor(elapsedMs / 60000);

  if (elapsedMinutes < 1) {
    return {
      key: "messages.timeAgo.justNow",
      params: {}
    };
  }

  if (elapsedMinutes < 60) {
    return {
      key: "messages.timeAgo.minutesAgo",
      params: {
        count: elapsedMinutes
      }
    };
  }

  const elapsedDays = getLocalDayNumber(referenceDate) - getLocalDayNumber(targetDate);

  if (elapsedDays === 0) {
    return {
      key: "messages.timeAgo.todayAt",
      params: {
        time: formatLocalTime(targetDate)
      }
    };
  }

  if (elapsedDays === 1) {
    return {
      key: "messages.timeAgo.yesterdayAt",
      params: {
        time: formatLocalTime(targetDate)
      }
    };
  }

  if (elapsedDays < 30) {
    return {
      key: "messages.timeAgo.daysAgo",
      params: {
        count: elapsedDays
      }
    };
  }

  return {
    key: "messages.timeAgo.daysAgoOnDate",
    params: {
      count: elapsedDays,
      date: formatLocalDate(targetDate)
    }
  };
}
